import styled from 'styled-components';

import { theme } from '_constants/theme';

import ComparingTable from '_components/atomic/ComparingTable';

const { colors, devices, fontSizes, spaces } = theme;

const ITEMS = [
  {
    key: 'item1',
    title: 'Full Service Incorporation Packages',
    description: 'Start to finish incorporation, hands off incorporation',
    iconAlias: null,
    iconColor: colors.gray[500],
  },
  {
    key: 'item2',
    title: 'No Gimmick Pricing',
    description: 'No hidden fees, unclear recurring pricing',
    iconAlias: null,
    iconColor: colors.gray[500],
  },
  {
    key: 'item3',
    title: 'Dedicated Account Manager',
    description:
      'Assigned a private account manager to answer all your questions ',
    iconAlias: null,
    iconColor: colors.gray[500],
  },
  {
    key: 'item4',
    title: 'Built for Small Business Owners',
    description: 'Catered around small business owners to minimize confusion',
    iconAlias: null,
    iconColor: colors.gray[500],
  },
  {
    key: 'item5',
    title: 'Satisfaction Guarantee',
    description:
      'If not up to your satisfaction, provide a money back guarantee',
    iconAlias: null,
    iconColor: colors.gray[500],
  },
  {
    key: 'item6',
    title: 'Additional Services Available',
    description: 'Provide additional services to help grow your business',
    iconAlias: null,
    iconColor: colors.gray[500],
  },
];

const COMPETITORS = [
  {
    key: 'Incorpified',
    title: 'Incorpified',
    itemKeys: ['item1', 'item2', 'item3', 'item4', 'item5', 'item6'],
  },
  {
    key: 'Companies',
    title: 'Companies',
    itemKeys: ['item1', 'item5', 'item6'],
  },
];

const StyledComparingSection = styled.div`
  max-width: ${spaces.large24X * 10 + 80}px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${devices.tablet} {
    padding: 0px;
  }
`;

const StyledTitle = styled.div`
  margin-bottom: ${spaces.large4X}px;
  font-family: 'Aeonik';
  font-style: normal;
  font-weight: 500;
  font-size: ${fontSizes.large11X}px;
  line-height: 150%;
  text-align: center;
  color: ${colors.gray[800]};

  @media ${devices.tablet} {
    margin-bottom: ${spaces.medium}px;
    font-size: ${fontSizes.large2X}px;
  }
`;

const ComparingSection = () => {
  return (
    <StyledComparingSection>
      <StyledTitle>Comparing to other competitors</StyledTitle>
      <ComparingTable competitors={COMPETITORS} items={ITEMS} />
    </StyledComparingSection>
  );
};

export default ComparingSection;
